module.exports = __webpack_public_path__ + "9889d422b9724f0c2887a13999d07edc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-2/icon_2-sec2.svg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-2/icon_2-sec2.svg
// module chunks = 40